import { render, staticRenderFns } from "./FilterLessThan.vue?vue&type=template&id=1b99a860&"
import script from "./FilterLessThan.vue?vue&type=script&lang=js&"
export * from "./FilterLessThan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b99a860')) {
      api.createRecord('1b99a860', component.options)
    } else {
      api.reload('1b99a860', component.options)
    }
    module.hot.accept("./FilterLessThan.vue?vue&type=template&id=1b99a860&", function () {
      api.rerender('1b99a860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/criterion/FilterLessThan.vue"
export default component.exports